import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';
import { DataTableCustomStyles } from '../../../../../helper/dataTable.config';
import { Schools } from "../../../../../models";
import Login from '../../../../../setup/auth/login.component';
import * as alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { toast } from "react-toastify";
import EditButton from '../../../../../components/buttons/EditButton';
import DeleteButton from '../../../../../components/buttons/DeleteButton';
import Layout from '../../../../../components/common/nav/admin/nav.component';
import { ValidateAdminRole } from '../../../../../helper/validateRole';
import { Auth } from 'aws-amplify';

export default function School() {

    //Validate admin Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    //State
    const [schoolList, SetSchoolList] = useState([]);
    let navigateTo = useNavigate();

    //*School Table Columns Name
    const parentDataTableColumns = [
        {
            name: "School Code",
            selector: row => row.code,
            sortable: true,
        },
        {
            name: "School Name",
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Address',
            selector: row => row.address,
            sortable: true,
        },

        {
            name: 'City',
            selector: row => row.city,
            sortable: true,
        },
        {
            name: 'Zip Code',
            selector: row => row.zip_code,
            sortable: true,
        },
        {
            name: 'State',
            selector: row => row.state_id,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row) => (
                <>
                    <div className="flex gap-4">
                        <Link onClick={(e) => handleEditClick(e, row['id'])} ><EditButton /></Link>
                        <Link onClick={(e) => handleDeleteClick(e, row['id'])} ><DeleteButton /></Link>
                    </div>
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            center: true,
            button: true,
        }
    ];



    //Edit Parent
    const handleEditClick = (e, id) => {
        e.preventDefault();
        navigateTo('/admin/setting/masters/createschool/' + id);
    };

    //Delete Schools
    const handleDeleteClick = async (e, id) => {
        e.preventDefault();
        const objDeleteSchool = await DataStore.query(Schools, id);
        alertify.confirm('Confirmation', 'Do you want to delete this record?', function () {
            //Delete Schools
            DataStore.delete(objDeleteSchool);
            toast.error("Deleted");
            BindList();
        }
            , function () { });
    };

    //Get School List
    const BindList = async () => {

        var ProgramTypeResponses = await DataStore.query(Schools, Predicates.ALL, {
            sort: s => s.name(SortDirection.ASCENDING)
        });
        console.log("ProgramTypeResponses0", ProgramTypeResponses)
        SetSchoolList(ProgramTypeResponses)

    }

    async function onLoad() {
        try {
           await Auth.currentSession();
           if (!ValidateAdminRole()) { userHasAuthenticated(false); }
        } catch (e) {
           console.log("error-->", e)
           userHasAuthenticated(false);
        }
     }

    useEffect(() => {
        onLoad();
        BindList();
    }, []);


    return isAuthenticated ? (
        <Layout pageTitle="Dashboard">
            <div>
                <div >
                    <div className="dashboard-main-wrapper mt-3">
                        <div className="flex flex-1 flex-wrap p-5 pb-4 px-0 top-action-wrapper">
                            <div className="md:flex xs:w-full sm:w-full md:w-auto flex-row align-center">
                                <div className="md:flex block md:col-span-2 mb-4">
                                </div>
                                <div className="md:flex block mb-4">
                                    <h2 className="page-title">Schools</h2>
                                </div>
                            </div>

                            <div className="md:flex flex-1 flex-row xs:w-full sm:w-full md:w-auto align-center justify-end md:ml-auto gap-3 right-side">

                                <div className="md:flex block  gap-3 mb-3">
                                    <Link to="/masters" className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium   shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]">Back</Link>
                                    <Link to="/admin/setting/masters/createschool" className=" py-2 px-6 bg-btn-blue text-[#fff] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md bg-[#113699]">Create</Link>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div className={"block w-full pt-5"}>
                                {
                                    <DataTable
                                        columns={parentDataTableColumns}
                                        data={schoolList}
                                        customStyles={DataTableCustomStyles}
                                        pagination
                                        highlightOnHover
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    ) : (
        <Login sessionExpired={1} />
    )
}
